const EVENT_TYPES_GTM = {
  initRegisteredSession: 'initRegisteredSession',
  login: 'login'
};

export default EVENT_TYPES_GTM;
